module.exports = __webpack_public_path__ + "static/media/Zone2LeftHipOverlay.e566b551.png";